import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Utility from '../../Utility/Utility';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getSponsorListApi } from "./SponsorController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";
import TopTeams from '../Components/TopTeams';
import { getTeamListApi } from '../Match/MatchController';

const Sponsor = () => {

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { language } = useSelector((state) => state.language);
    const dispatch = useDispatch();

    const [sponsorList, setSponsorList] = useState([]);
    const [teamList, setTeamList] = useState([]);

    useEffect(() => {
        getSponsorList();
        getTeamList();
    }, []);

    const getSponsorList = () => {
        try {
            dispatch(loaderStateTrue());
            getSponsorListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    setSponsorList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    const getTeamList = () => {
        try {
            dispatch(loaderStateTrue());
            getTeamListApi()
                .then((response) => {
                    let responseData = response.data || [];
                    console.log("responseDataresponseDataresponseData", responseData)
                    setTeamList(responseData);
                    dispatch(loaderStateFalse());
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(loaderStateFalse());
                });
        } catch (error) {
            console.log(error);
            dispatch(loaderStateFalse());
        }
    };

    return (
        <main className="main p-4 relative">
            <div className="flex flex-col">
                <div className="flex flex-wrap items-start gap-y-6 -mx-2">
                    <div className="lg:w-4/6 w-full px-2">
                        <div className="space-y-5">
                            <div className="overflow-x-auto space-y-4">
                                <table className="table table-striped table-row-hover w-full">
                                    <thead className="border-b light-border">
                                        {/* <tr>
                                            <th className="text-lg font-bold" colSpan={4}>Defenders - 8</th>
                                        </tr> */}
                                        <tr>
                                            <th className="text-lg font-bold">S.No</th>
                                            <th className="text-lg font-bold">Sponsor Name</th>
                                            <th className="text-lg font-bold">Rating</th>
                                            {/* <th className="text-lg font-bold">Status</th> */}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {sponsorList.map((element, index) => (
                                            <tr key={index} className={`${element?.teamJoinStatus === "approved" ? "opacity-30" : ""}`}>
                                                <td width={32} className='w-20'>
                                                    <label className="relative inline-flex items-center gap-1.5 cursor-pointer">
                                                        <span className="font-secondary font-semibold text-nowrap">#1</span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <div className="flex max-sm:flex-wrap items-center gap-3">
                                                        <div className="w-10">
                                                            <img className="w-full" src={`${element?.photo || "assets/images/players-list/4.png"}`} alt="" />
                                                        </div>
                                                        <div>
                                                            <p className="font-bold uppercase">{element?.fullName}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className='text-right'>
                                                    <span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
                                                        <img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 4.5
                                                    </span>
                                                </td>
                                                {/* <td className='text-right'>
                                                    <button onClick={() => handlePlayerStatus(element?._id)} className="btn btn-primary text-nowrap ml-auto">{element?.teamJoinStatus}</button>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">

                        <div className="space-y-5">
                            <div className="panel">
                                {/* <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
                                    <div className="flex justify-between gap-3 w-full">
                                        <button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button>
                                        <h3 className="xl:text-lg text-base font-extrabold uppercase">Lecture en cours</h3>
                                        <button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button>
                                    </div>
                                </div> */}
                                <div className="panel-body w-full space-y-8">
                                    <div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
                                        <div className="p-5 relative space-y-3">
                                            <div className="flex justify-between items-center gap-4 w-full">
                                                <div className="flex-1 font-secondary lg:text-3xl text-2xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">sÊrie de victoires</div>
                                                <div className="flex-none pr-5">
                                                    <span className="flex-1 font-secondary lg:text-5xl text-4xl uppercase font-black ">70%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TopTeams tableName={"best-teams"} teamList={teamList} />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Sponsor